export default [

     {
          path: '/room',
          name: 'Room',
          component: () => import("@/views/Page/Room/Room.vue"),
           meta: {
               title: '#Default# | Room',
          },
     }
];